export const PORT_LOCATION_TYPE = {
  LONG: 'long',
  SHORT: 'short',
  SYSTEM: 'system'
}

export const PORT_DIR_TYPE = {
  LEFT: 'left',
  UP: 'up',
  SYSTEM: 'system'
}

export const SAVE_TYPE = {
  RECTANGLE: 1, // 方形
  CIRCLE: 2, // 圆形
  RING: 3, // 环形
  CAD: 4, // CAD导入
  CUSTOM: 5, // 自定义
  TEMPLATE: 6 // 模版
}

export const SHAPE_SUB_TYPE = {
  // 方形
  RECTANGLE: 'rectangle', // 模组75*75
  RECTANGLE_MODULE: 'rectangle_module', // 组合模组（75*75、100*600、600*600）
  RECTANGLE_PLATE: 'rectangle_plate', // 模组P40
  RECTANGLE_BAR: 'rectangle_bar', // 线形灯
  RECTANGLE_FRAME: 'rectangle_frame', // 带框模组
  // 圆形
  CIRCLE: 'circle', // 模组75*75
  CIRCLE_BAR: 'circle_bar', // 线形灯
  // 异形
  IRREGULAR: 'irregular', // 模组75*75
}

export const LIGHT_TYPE = {
  FACE_MODULE: 'faceModule', // 面光源
  LAMP_MODULE: 'lampModule', // 灯模组
  LINE_MODULE: 'lineModule', // 线形灯
}

export const LINE_LIGHT_TYPE = {
  1: 'singleOffset',
  2: 'doubleOffset',
  0: 'directDown',
}

export const WINDOW_SHADOW_TYPE = {
  0: 'noWindowShadow',
  1: 'windowShadow',
}
